import { gsap, Power2 } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

function initGsap() {
  gsap.registerPlugin( ScrollTrigger );

  ScrollTrigger.matchMedia({
    '(min-width: 1024px)': () => {
      gsap.from('.dynamic-image-animate', {
        scrollTrigger: {
          trigger: '.dynamic-image',
          start: 'top bottom',
          toggleActions: 'play pause resume reset',
        },
        stagger: 0.3,
        duration: 1,
        opacity: 0,
        y: 100,
        rotation: 3,
        ease: Power2.out,
      });
    },
  });
}

function initEvents() {
  document.addEventListener('lazyloaded', () => {
    ScrollTrigger.refresh();
  });
}

function init() {
  initGsap();
  initEvents();
}

export default {
  init,
};